import React from 'react';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import StaticImage from '../UI/Image/StaticImage';
import './Discover.scss';
import { sendEvent } from '../../utils';

type DiscoverProps = {
  context?: IContent;
};

const Discover: React.FC<DiscoverProps> = ({
                                             context: {
                                               discover: {
                                                 title,
                                                 description,
                                                 cta: { type, content, link, tracking },
                                                 image
                                               }
                                             }
                                           }) => {
  return (
    <div className='wallet-container wallet-banner'>
      <div className='wallet-banner__content'>
        <h2 className='wallet-banner__content__title' dangerouslySetInnerHTML={{ __html: title }} />
        <div className='wallet-banner__content__subtitle'>{description}</div>
        <a
          href={link}
          className={`tablet-n-up btn btn__${type}`}
          data-alt-text={content}
          onClick={() => sendEvent(tracking)}
        >
          <span>{content}</span>
        </a>
      </div>
      <div className='wallet-banner__image-container'>
        <StaticImage imageName={image} extension='png' altText='' />
      </div>
      <div className='cta-wrapper'>
        <a
          href={link}
          className={`mobile-only btn btn__${type}`}
          data-alt-text={content}
          onClick={() => sendEvent(tracking)}
        >
          <span>{content}</span>
        </a>
      </div>
    </div>
  );
};

export default withContent(Discover);
